import { render, staticRenderFns } from "./addmessage.vue?vue&type=template&id=d9b2e100&scoped=true"
import script from "./addmessage.vue?vue&type=script&lang=js"
export * from "./addmessage.vue?vue&type=script&lang=js"
import style0 from "./addmessage.vue?vue&type=style&index=0&id=d9b2e100&prod&scoped=true&lang=css"
import style1 from "./addmessage.vue?vue&type=style&index=1&id=d9b2e100&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b2e100",
  null
  
)

export default component.exports